import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import Table$2 from './Desktop/Table.js';
import Table$1 from './Mobile/Table.js';
import useIsLowerResolution from '../../hooks/useIsLowerResolution.js';

const Table = forwardRef((_a, ref) => {
    var { rows, columns, onSort, seeMoreInfoButtonText, seeMoreInfoModalTitleText, PlaceholderElement } = _a, props = __rest(_a, ["rows", "columns", "onSort", "seeMoreInfoButtonText", "seeMoreInfoModalTitleText", "PlaceholderElement"]);
    const isLowerResolution = useIsLowerResolution();
    return isLowerResolution ? (React.createElement(Table$1, Object.assign({ rows: rows, columns: columns, seeMoreInfoButtonText: seeMoreInfoButtonText, seeMoreInfoModalTitleText: seeMoreInfoModalTitleText, PlaceholderElement: PlaceholderElement, ref: ref }, props))) : (React.createElement(Table$2, Object.assign({ ref: ref, rows: rows, columns: columns, onSort: onSort, PlaceholderElement: PlaceholderElement }, props)));
});
Table.displayName = 'Table';

export { Table };
